
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { OrderLineModel } from './Entities.GormCrm.OrderLine';
import { Model, ModelProperty } from 'models/Model';


export class OrderLineCommissionModel extends Model<OrderLineCommissionModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'orderLineId', type: 'string' },
		{ name: 'acvExtend', type: 'number' },
		{ name: 'acvIncrease', type: 'number' },
		{ name: 'upFront', type: 'number' },
		{ name: 'oneOff', type: 'number' },
		{ name: 'acvExtendCommissionEnabled', type: 'boolean' },
		{ name: 'acvIncreaseCommissionEnabled', type: 'boolean' },
		{ name: 'upFrontCommissionEnabled', type: 'boolean' },
		{ name: 'oneOffCommissionEnabled', type: 'boolean' },
		{ name: 'orderLine', type: 'OrderLineModel', isHidden: true, isObject: true, new: () => { return new OrderLineModel }, properties: () => { return OrderLineModel.classProperties } }
	];
	[key: string]: any;
	
	public orderLineId?: string;
	public acvExtend: number;
	public acvIncrease: number;
	public upFront: number;
	public oneOff: number;
	public acvExtendCommissionEnabled: boolean;
	public acvIncreaseCommissionEnabled: boolean;
	public upFrontCommissionEnabled: boolean;
	public oneOffCommissionEnabled: boolean;
	public orderLine?: OrderLineModel;
    
	constructor(){
		super();
		this.orderLineId = undefined;
		this.acvExtend = 0;
		this.acvIncrease = 0;
		this.upFront = 0;
		this.oneOff = 0;
		this.acvExtendCommissionEnabled = false;
		this.acvIncreaseCommissionEnabled = false;
		this.upFrontCommissionEnabled = false;
		this.oneOffCommissionEnabled = false;
		this.orderLine = undefined;
		
	}
	getProperties(){
		return OrderLineCommissionModel.classProperties;
	}
}

